.dg{padding:0.5rem;}